/**
 * The PATCH body of a move — the ONE place the rule lives.
 *
 * Clearing the parent detaches the asset to the root, which is a legitimate
 * move, hence an explicit `null` rather than an early return like the asset
 * type. Shared by the property registry's identity row, the header's Move
 * dialog and the hierarchy rail's drag & drop, so the three cannot drift
 * (spec 2026-09-18-01).
 *
 * It lives here rather than next to one of its three callers so that neither
 * of the two hook modules has to import the other.
 */
export function parentAssetPatchBody(parentUid: string | null): Record<string, unknown> {
    return { parent_asset_uid: parentUid || null }
}
